import styled from "styled-components";

export const IconButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "transparent"};
  border: 0;
  cursor: pointer;
  padding: 0;
  font-size: ${props => (props.fontSize ? props.fontSize : "24px")};
  width: ${({ width }) => (width ? width : "auto")};
  color: ${({ theme, fillColor }) =>
    fillColor ? fillColor : theme.editor.textLight};

  &:focus {
    outline: none;
  }

  /* Do NOT add a "path { fill }" rule here.
     CSS rules on path override SVG presentation attributes (including
     fill="none" on the parent svg), which turns outline icons into
     solid silhouettes. All asset components either set their own
     fill inline (legacy filled icons) or use
     fill="none" stroke="currentColor" (outline icons) — both work
     correctly via the color rule above. */

  &:hover {
    color: ${({ theme }) => theme.editor.textGrey};
  }

  svg {
    width: ${({ svgWidth }) => (svgWidth ? svgWidth : "auto")};
    height: ${({ svgHeight }) => (svgHeight ? svgHeight : "auto")};
  }
`;
